const initialState = {
  abnormalMotionSettings: {},
  hrmSettings: {},
  fallDetectionSettings: {},
  callForHelpSettings: {},
  days: [
    {
      label: "monday",
      key: 1
    },
    {
      label: "tuesday",
      key: 2
    },
    {
      label: "wednesday",
      key: 3
    },
    {
      label: "thursday",
      key: 5
    },
    {
      label: "friday",
      key: 5
    },
    {
      label: "saturday",
      key: 6
    },
    {
      label: "sunday",
      key: 7
    },
  ]
};
/**
 * teporary save the state of passwords if user change his password
 * @param {object} state
 * @param {object} action
 */
const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ABNORMAL_MOTION_SETTINGS":
      return { ...state, abnormalMotionSettings: action.payload.abnormalMotionSettings };

    case "SET_HRM_SETTINGS":
      return { ...state, hrmSettings: action.payload.hrmSettings };

    case "SET_FALL_DETECTION_SETTINGS":
      return { ...state, fallDetectionSettings: action.payload.fallDetectionSettings };

    case "SET_CALL_FOR_HELP_SETTINGS":
      return { ...state, callForHelpSettings: action.payload.callForHelpSettings };

    default:
      return state;
  }
};

export default settingsReducer;
